import * as React from 'react';
import { ModalBase } from '../components/ModalBase';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import { FlexBoxInline, InputBaseSx, PrimaryBtnSx } from '../@shared/templates';
import { Palette, Sizes } from '../@shared/palette';
import { useManageSubscription } from '../hooks/useManageSubscription';
import { SubscriptionUserItem } from './components/SubscriptionUserItem';
import { User } from '../@shared/Models/Models';
import { useSelector } from 'react-redux';
import { getIsAuthorized, getSeats } from '../reducers/main/mainReducer';

export const withManageSubscription = <T extends Record<string, unknown>>(
  Component: React.ComponentType<T>
): React.FC<T> => (props) => {
  const {
    onAssign,
    onUnassign,
    isDialogOpen,
    setIsDialogOpen,
    searchData,
    searchValue,
    setSearchValue
  } = useManageSubscription();
  const [selectedUser, setSelectedUser] = React.useState<User | null>(null);
  const user = useSelector(getIsAuthorized)
  const seats = useSelector(getSeats)
  const ref = React.useRef<HTMLDivElement>(null)
  const ownerId = React.useMemo(() =>
    user?.license?.licensedUsers.find(x => x.isOwner)?.externalUserId
    , [user])
  return <>
    <ModalBase
      isOpen={isDialogOpen}
      onCancel={() => setIsDialogOpen(false)}
      title="Manage subscription"
    >
      <Box
        sx={{
          ...FlexBoxInline,
          width: '100%',
          padding: '0 0',
          marginBottom: '10px'
        }}
      >
        <Autocomplete
          id="user-selector"
          sx={{ ...InputBaseSx, width: '100%' }}
          size='small'
          ref={ref}
          onInputChange={(_, str) => {
            setSearchValue(str)
          }}
          slotProps={
            {
              paper: {
                sx: {
                  fontSize: Sizes.textPrimary,
                  color: Palette.textColorPrimary,
                  backgroundColor: Palette.backgroundColorPrimary
                }
              }
            }
          }
          onChange={(_, newValue) => {
            setSelectedUser(newValue);
          }}
          value={selectedUser}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          options={searchData}
          getOptionLabel={x => x.email}
          inputValue={searchValue}
          renderInput={(params) => <TextField {...params} label="Search" />}
        />

        <Button sx={PrimaryBtnSx} disabled={!selectedUser} onClick={() => {
          onAssign(selectedUser!.id);
          setSelectedUser(null);
        }}>Assign</Button>
      </Box>


      <Box sx={{
        width: '100%',
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}>
        {seats && seats.map((value) => <SubscriptionUserItem isOwner={ownerId === value.id} key={value.id} user={value} onRemoveAccess={onUnassign} />)}
      </Box>
    </ModalBase>
    <Component {...props as T} />
  </>
}